<template>
  <div>
    <div class="nk-app-root">
      <!-- main @s -->
      <div class="nk-main">
        <!-- wrap @s -->
        <div class="nk-wrap">
          <Header v-show="!loading_page" />
          <!-- main header @e -->
          <!-- content @s -->
          <div class="nk-content">
            <div class="container wide-xl">
              <div class="nk-content-inner">
                <Navigation v-show="!loading_page" />
                <!--
                <div class="nk-content-body" v-show="loading_page">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
                -->
                <div class="nk-content-body" v-show="!loading_page">
                  <div class="nk-content-wrap">
                    <div class="nk-block-head nk-block-head-lg">
                      <div class="nk-block-head-sub">
                        <span>8.2 Inspect</span>
                      </div>
                      <div class="nk-block-head-content">
                        <h2 class="nk-block-title fw-normal">
                          User List
                        </h2>
                      </div>
                    </div>

                    <div class="nk-block">
                      <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                          <div class="card-inner">
                            <div class="card-title-group">
                              {{ bookingList.length }} Entries
                              <div class="card-tools mr-n1">
                                <ul class="btn-toolbar">

                                  <!-- li -->
                                  <li class="btn-toolbar-sep"></li>
                                  <!-- li -->

                                  <li>
                                    <div class="dropdown">
                                      <a href="#" class="
                                          btn btn-trigger btn-icon
                                          dropdown-toggle
                                        " data-toggle="dropdown">
                                        <em class="icon ni ni-setting"></em>
                                      </a>
                                      <div class="
                                          dropdown-menu
                                          dropdown-menu-right
                                          dropdown-menu-xs
                                        ">
                                        <ul class="link-check">
                                          <li>
                                            <span style="cursor: pointer" @click="exportCSV()">Export CSV</span>
                                          </li>

                                        </ul>
                                      </div>
                                    </div>
                                  </li>

                                  <!-- li -->
                                </ul>
                                <!-- .btn-toolbar -->
                              </div>
                              <!-- card-tools -->
                              <div class="card-search search-wrap" data-search="search">
                                <div class="search-content">
                                  <a href="#" class="
                                      search-back
                                      btn btn-icon
                                      toggle-search
                                    " data-target="search"><em class="icon ni ni-arrow-left"></em></a>
                                  <input type="text" class="
                                      form-control form-control-sm
                                      border-transparent
                                      form-focus-none
                                    " placeholder="Quick search by order id" />
                                  <button class="search-submit btn btn-icon">
                                    <em class="icon ni ni-search"></em>
                                  </button>
                                </div>
                              </div>
                              <!-- card-search -->
                            </div>
                            <!-- .card-title-group -->
                          </div>

                          <div class="card-inner">
                            <div class="form-group">
                              <input type="text" id="search" class="form-control" v-model="searchQuery"
                                placeholder="Search..." />
                            </div>

                            <div class="form-group">
                              <label class="form-label">Filter</label>
                              <div class="row gy-2">
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <label class="form-label" for="filterLogin">Login System</label>
                                    <div class="form-control-select">
                                      <select class="form-control" id="filterLogin" v-model="filters.loginSystem">
                                        <option value="">All</option>
                                        <option v-for="system in availableLoginSystems" :key="system" :value="system">
                                          {{ system }}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div class="custom-control custom-checkbox" style="margin-top: 32px;">
                                    <input type="checkbox" class="custom-control-input" id="filterLicence"
                                      v-model="filters.hasLicence" />
                                    <label class="custom-control-label" for="filterLicence">Has Licence</label>
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div class="custom-control custom-checkbox" style="margin-top: 32px;">
                                    <input type="checkbox" class="custom-control-input" id="filterPaid"
                                      v-model="filters.hasPaid" />
                                    <label class="custom-control-label" for="filterPaid">Has Paid</label>
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div class="custom-control custom-checkbox" style="margin-top: 32px;">
                                    <input type="checkbox" class="custom-control-input" id="filterLeft"
                                      v-model="filters.hasLeft" />
                                    <label class="custom-control-label" for="filterLeft">User Left</label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- .card-inner -->
                          <div class="card-inner p-0">
                            <table class="table table-tranx">
                              <thead>
                                <tr class="tb-tnx-head">
                                  <th class="tb-tnx-id" style="width: 50px">
                                    <span class="">#</span>
                                  </th>
                                  <th style="width: 100px;cursor:pointer;" @click="sortBy('created_at')">
                                    <span class="tb-tnx-total">Date</span>
                                  </th>
                                  <th style="cursor:pointer;" @click="sortBy('company')">Company</th>
                                  <th style="cursor:pointer;" @click="sortBy('username')">User</th>
                                  <th style="cursor:pointer;" @click="sortBy('login_system')">Login</th>
                                  <th style="cursor:pointer;" @click="sortBy('licence')">Licence</th>
                                  <th style="cursor:pointer;" @click="sortBy('licence_paid')">Paid</th>
                                  <th style="cursor:pointer;" @click="sortBy('user_left')">Left</th>
                                </tr>
                                <!-- tb-tnx-item -->
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in filteredBookingList" :key="item._id" class="table-row"
                                  @click="selectUser(item)">
                                  <td class="tb-tnx-id">
                                    <span>{{ index + 1 }}</span>
                                  </td>
                                  <td class="tb-tnx-info">
                                    <span class="date">{{ item.created_at | moment("DD.MM.YY")
                                    }}</span>
                                  </td>
                                  <td class="tb-tnx-info">
                                    {{ item.company }}
                                  </td>
                                  <td class="tb-tnx-info">{{ item.username }}<br />
                                    {{ item.name }}</td>
                                  <td class="tb-tnx-info">{{ item.login_system }}</td>
                                  <td class="tb-tnx-info">
                                    <em v-if="item.licence" class="ni ni-check " style="font-size:24px;"></em>
                                  </td>
                                  <td class="tb-tnx-info">
                                    <em v-if="item.licence_paid" class="ni ni-coins" style="font-size:24px;"></em>
                                  </td>
                                  <td class="tb-tnx-info">
                                    <em v-if="item.user_left" class="ni ni-user-cross" style="font-size:24px;"></em>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!-- .card-inner -->

                          <!-- .card-inner -->
                        </div>
                        <!-- .card-inner-group -->
                      </div>
                      <!-- .card -->
                    </div>

                  </div>

                  <div class=" modal fade" id="modalDefault">
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <a href="#" class="close" data-dismiss="modal" aria-label="Close">
                          <em class="icon ni ni-cross"></em>
                        </a>
                        <div class="modal-header">
                          <h5 class="modal-title">User</h5>
                        </div>
                        <div class="modal-body">

                          <form action="#" class="form-validate is-alter" novalidate="novalidate">
                            <div class="form-group">
                              <div class="row gy-4">
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Name</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" readonly="" v-model="userEntry.name" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Username</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" readonly=""
                                        v-model="userEntry.username" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Company</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" readonly="" v-model="userEntry.company" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row gy-4">
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Login System</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" readonly=""
                                        v-model="userEntry.login_system" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Created</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" readonly=""
                                        :value="userEntry.created_at | moment('DD.MM.YYYY HH:mm')" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Updated</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" readonly=""
                                        :value="userEntry.updated_at | moment('DD.MM.YYYY HH:mm')" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <h4 class="mt-5">Licence Info</h4>
                            <div class="form-group">
                              <div class="row gy-4">
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01"></label>
                                    <div class="form-control-wrap">
                                      <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck5"
                                          v-model="userEntry.licence" />
                                        <label class="custom-control-label" for="customCheck5">Valid
                                          licence</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Date</label>
                                    <div class="form-control-wrap">
                                      <input type="date" class="form-control " v-model="userEntry.licence_date">
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Invoice</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" v-model="userEntry.licence_invoice" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row gy-4">
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01"></label>
                                    <div class="form-control-wrap">
                                      <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck8"
                                          v-model="userEntry.licence_paid" />
                                        <label class="custom-control-label" for="customCheck8">Licence
                                          paid</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Info</label>
                                    <div class="form-control-wrap">
                                      <input type="text" class="form-control" v-model="userEntry.licence_info" />
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01">Notes</label>
                                    <div class="form-control-wrap">
                                      <textarea class="form-control no-resize" v-model="userEntry.licence_notes"
                                        id="default-textarea">Notes..</textarea>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div class="form-group">
                              <div class="row gy-4">
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label" for="default-01"></label>
                                    <div class="form-control-wrap">
                                      <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="customCheck9"
                                          v-model="userEntry.user_left" />
                                        <label class="custom-control-label" for="customCheck9">User
                                          left</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h4 class="mt-5">Datenstamm (DM)</h4>
                            <div class="form-group">
                              <div class="row gy-4">
                                <div class="col-sm-4">
                                  <div class="form-group">
                                    <label class="form-label">DM Rolle</label>
                                    <div class="form-control-select">
                                      <select class="form-control" v-model="userEntry.dm_rolle">
                                        <option :value="null">Keine</option>
                                        <option value="Leserecht">Leserecht</option>
                                        <option value="Betreiber">Betreiber</option>
                                        <option value="Pruefer">Prüfer</option>
                                        <option value="Projektleiter">Projektleiter</option>
                                        <option value="Admin">Admin</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-8">
                                  <div class="form-group" v-if="userEntry.dm_rolle !== null && userEntry.dm_rolle !== undefined">
                                    <label class="form-label">DM Berechtigungen</label>
                                    <div class="perm-grid">
                                      <label class="perm-item" :class="{ 'perm-item-active': dmBerechtigungenLocal.datenstamm_bestaetigen }">
                                        <input type="checkbox" v-model="dmBerechtigungenLocal.datenstamm_bestaetigen" class="perm-input" />
                                        <span class="perm-icon"><em class="icon ni ni-check-circle"></em></span>
                                        <span class="perm-text">Datenstamm bestätigen</span>
                                      </label>
                                      <label class="perm-item" :class="{ 'perm-item-active': dmBerechtigungenLocal.preisliste_bearbeiten }">
                                        <input type="checkbox" v-model="dmBerechtigungenLocal.preisliste_bearbeiten" class="perm-input" />
                                        <span class="perm-icon"><em class="icon ni ni-edit"></em></span>
                                        <span class="perm-text">Preisliste bearbeiten</span>
                                      </label>
                                      <label class="perm-item" :class="{ 'perm-item-active': dmBerechtigungenLocal.dokumente_freigeben }">
                                        <input type="checkbox" v-model="dmBerechtigungenLocal.dokumente_freigeben" class="perm-input" />
                                        <span class="perm-icon"><em class="icon ni ni-file-check"></em></span>
                                        <span class="perm-text">Dokumente freigeben</span>
                                      </label>
                                      <label class="perm-item" :class="{ 'perm-item-active': dmBerechtigungenLocal.benutzer_verwalten }">
                                        <input type="checkbox" v-model="dmBerechtigungenLocal.benutzer_verwalten" class="perm-input" />
                                        <span class="perm-icon"><em class="icon ni ni-users"></em></span>
                                        <span class="perm-text">Benutzer verwalten</span>
                                      </label>
                                      <label class="perm-item" :class="{ 'perm-item-active': dmBerechtigungenLocal.zugriff_alle_anlagen }">
                                        <input type="checkbox" v-model="dmBerechtigungenLocal.zugriff_alle_anlagen" class="perm-input" />
                                        <span class="perm-icon"><em class="icon ni ni-globe"></em></span>
                                        <span class="perm-text">Zugriff alle Anlagen</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Zugriffsbeschränkungen: Anlagentypen -->
                            <div class="form-group" v-if="userEntry.dm_rolle !== null && userEntry.dm_rolle !== undefined && !dmBerechtigungenLocal.zugriff_alle_anlagen">
                              <div class="row gy-4">
                                <div class="col-sm-12">
                                  <div class="form-group">
                                    <label class="form-label">{{ $t('dm_user_label_allowed_types') }}</label>
                                    <div class="d-flex" style="gap: 8px;">
                                      <label class="perm-item perm-item-sm" :class="{ 'perm-item-active': dmBerechtigungenLocal.erlaubte_anlage_typen && dmBerechtigungenLocal.erlaubte_anlage_typen.indexOf('WEA') !== -1 }">
                                        <input type="checkbox" class="perm-input" :checked="dmBerechtigungenLocal.erlaubte_anlage_typen && dmBerechtigungenLocal.erlaubte_anlage_typen.indexOf('WEA') !== -1" @change="toggleAnlageTyp('WEA')" />
                                        <span class="perm-text">WEA</span>
                                      </label>
                                      <label class="perm-item perm-item-sm" :class="{ 'perm-item-active': dmBerechtigungenLocal.erlaubte_anlage_typen && dmBerechtigungenLocal.erlaubte_anlage_typen.indexOf('PV') !== -1 }">
                                        <input type="checkbox" class="perm-input" :checked="dmBerechtigungenLocal.erlaubte_anlage_typen && dmBerechtigungenLocal.erlaubte_anlage_typen.indexOf('PV') !== -1" @change="toggleAnlageTyp('PV')" />
                                        <span class="perm-text">PV</span>
                                      </label>
                                      <label class="perm-item perm-item-sm" :class="{ 'perm-item-active': dmBerechtigungenLocal.erlaubte_anlage_typen && dmBerechtigungenLocal.erlaubte_anlage_typen.indexOf('BAT') !== -1 }">
                                        <input type="checkbox" class="perm-input" :checked="dmBerechtigungenLocal.erlaubte_anlage_typen && dmBerechtigungenLocal.erlaubte_anlage_typen.indexOf('BAT') !== -1" @change="toggleAnlageTyp('BAT')" />
                                        <span class="perm-text">BAT</span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="form-group">
                              <button type="button" v-if="canSave" class="btn btn-lg btn-primary" @click="saveUser()">
                                Save user
                              </button>
                            </div>
                          </form>
                        </div>
                        <div class="modal-footer bg-light">

                        </div>
                      </div>
                    </div>
                  </div>

                  <Footer />
                </div>
              </div>
            </div>
          </div>
          <!-- content @e -->
        </div>
        <!-- wrap @e -->
      </div>
      <!-- main @e -->
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import Navigation from "../../components/Navigation.vue";
import Footer from "../../components/Footer.vue";

import { getUsers, updateUser } from "@/services/account.service";

//import { EventBus } from '@/event-bus.js';

export default {
  name: "Home",
  data() {
    return {
      fullLoader: null,
      projectEntry: {},
      mapSort: {},
      searchkey: "",
      db_result: [],
      canSave: true,
      projectLoading: false,
      iec_daaks_value: "",
      settingsSaved: false,
      bookingDate: null,
      bookingList: [],
      userEntry: [],
      searchQuery: "",
      dmBerechtigungenLocal: {
        datenstamm_bestaetigen: false,
        preisliste_bearbeiten: false,
        dokumente_freigeben: false,
        benutzer_verwalten: false,
        zugriff_alle_anlagen: false,
        erlaubte_anlage_typen: [],
      },
      filters: {
        loginSystem: "",
        hasLicence: false,
        hasPaid: false,
        hasLeft: false,
      },
    };
  },
  components: {
    Header,
    Navigation,
    Footer
  },

  computed: {
    availableLoginSystems() {
      const systems = new Set();
      this.bookingList.forEach(item => {
        if (item.login_system && item.login_system.trim() !== "") {
          systems.add(item.login_system.trim());
        }
      });
      return Array.from(systems).sort();
    },
    filteredBookingList() {
      let filtered = [...this.bookingList];

      // Text search filter
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter((item) => {
          const company = item.company ? item.company.toLowerCase() : "";
          const name = item.name ? item.name.toLowerCase() : "";
          return company.includes(query) || name.includes(query);
        });
      }

      // Login System Filter
      if (this.filters.loginSystem && this.filters.loginSystem !== "") {
        const filterLogin = this.filters.loginSystem.trim();
        filtered = filtered.filter((item) => {
          const itemLogin = item.login_system ? item.login_system.trim() : "";
          return itemLogin === filterLogin;
        });
      }

      // Licence Filter
      if (this.filters.hasLicence) {
        filtered = filtered.filter((item) => item.licence === true);
      }

      // Paid Filter
      if (this.filters.hasPaid) {
        filtered = filtered.filter((item) => item.licence_paid === true);
      }

      // Left Filter
      if (this.filters.hasLeft) {
        filtered = filtered.filter((item) => item.user_left === true);
      }

      return filtered;
    },
    account_role_permissions: function () {
      return this.$store.state.account_role.permissions == "write";
    },
    users_role_permissions: function () {
      return this.$store.state.account_role.users == "write";
    },
    companyName: function () {
      return this.$store.state.company;
    },
    loginName: function () {
      return this.$store.state.name;
    },

    loading_page: function () {
      return (
        this.$store.state.loading_page &&
        this.$store.state.loading_page == "setup"
      );
    },
  },
  mounted() {
    window.scrollTo(0, 0);

    if (!this.users_role_permissions) {
      this.$store.dispatch("api_error", {});
    }

    this.actionGetUsers();
  },
  created() { },
  watch: {},
  methods: {
    saveUser: function () {
      this.showLoader();

      this.userEntry.dm_berechtigungen = Object.assign({}, this.dmBerechtigungenLocal);
      console.log(this.userEntry);
      $("#modalDefault").modal("hide");

      updateUser(this.userEntry).then((d) => {
        console.log(d);

        this.hideLoder();
      });

      /*
      getUsers(false).then((d) => {
        console.log(d);

        this.bookingList = d.data.list;

        this.hideLoder();
      });
      */
    },
    selectUser: function (data) {
      console.log(data);
      this.userEntry = data;
      var b = data.dm_berechtigungen || {};
      this.dmBerechtigungenLocal = {
        datenstamm_bestaetigen: !!b.datenstamm_bestaetigen,
        preisliste_bearbeiten: !!b.preisliste_bearbeiten,
        dokumente_freigeben: !!b.dokumente_freigeben,
        benutzer_verwalten: !!b.benutzer_verwalten,
        zugriff_alle_anlagen: !!b.zugriff_alle_anlagen,
        erlaubte_anlage_typen: Array.isArray(b.erlaubte_anlage_typen) ? b.erlaubte_anlage_typen.slice() : [],
      };
      $("#modalDefault").modal("show");
    },
    toggleAnlageTyp(typ) {
      var arr = this.dmBerechtigungenLocal.erlaubte_anlage_typen || [];
      var idx = arr.indexOf(typ);
      if (idx === -1) {
        arr.push(typ);
      } else {
        arr.splice(idx, 1);
      }
      this.$set(this.dmBerechtigungenLocal, 'erlaubte_anlage_typen', arr);
    },
    sortByKey(key, idx) {
      return (a, b) => {
        // Besondere Behandlung für null, undefined oder gemischte Typen
        if (a[key] === null || a[key] === undefined) return idx === -1 ? -1 : 1;
        if (b[key] === null || b[key] === undefined) return idx === -1 ? 1 : -1;

        // Bei booleschen Werten konvertieren wir explizit zu 0 und 1
        if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
          return idx === -1
            ? (a[key] === b[key] ? 0 : (a[key] ? 1 : -1))
            : (a[key] === b[key] ? 0 : (a[key] ? -1 : 1));
        }

        // Standardvergleich für andere Typen
        return idx === -1
          ? (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0)
          : (a[key] > b[key] ? -1 : b[key] > a[key] ? 1 : 0);
      };
    },
    sortBy: function (val) {
      if (!this.mapSort[val]) {
        this.mapSort[val] = 1;
      } else {
        this.mapSort[val] = this.mapSort[val] * -1;
      }

      this.bookingList = this.bookingList.sort(
        this.sortByKey(val, this.mapSort[val])
      );

    },
    exportCSV: function () {
      this.showLoader();

      // Generate CSV in frontend with all user fields
      const headers = [
        'Company',
        'Username',
        'Name',
        'Login System',
        'Created',
        'Updated',
        'Valid Licence',
        'Licence Date',
        'Invoice',
        'Licence Paid',
        'Info',
        'Notes',
        'User Left'
      ];
      const rows = [headers];

      this.bookingList.forEach(item => {
        const row = [
          item.company || '',
          item.username || '',
          item.name || '',
          item.login_system || '',
          item.created_at ? this.$moment(item.created_at).format('YYYY-MM-DD') : '',
          item.updated_at ? this.$moment(item.updated_at).format('YYYY-MM-DD') : '',
          item.licence ? 'Yes' : 'No',
          item.licence_date ? this.$moment(item.licence_date).format('YYYY-MM-DD') : '',
          item.licence_invoice || '',
          item.licence_paid ? 'Yes' : 'No',
          item.licence_info || '',
          item.licence_notes || '',
          item.user_left ? 'Yes' : 'No'
        ];
        rows.push(row);
      });

      // Convert to CSV string
      const csvContent = rows.map(row =>
        row.map(cell => {
          // Escape quotes and wrap in quotes if contains comma, quote or newline
          const cellStr = String(cell);
          if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
            return '"' + cellStr.replace(/"/g, '""') + '"';
          }
          return cellStr;
        }).join(',')
      ).join('\n');

      // Create and download file
      var csvData = new Blob(["\uFEFF" + csvContent], {
        type: "text/csv;charset=utf-8",
      });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, "inspect3_userlist.csv");
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute(
        "download",
        "inspect3_userlist.csv"
      );
      tempLink.click();

      this.hideLoder();
    },
    actionGetUsers: function () {

      this.showLoader();
      getUsers(false).then((d) => {
        console.log(d);

        this.bookingList = d.data.list;

        this.hideLoder();
      });

    },
    hideLoder: function () {
      if (this.fullLoader) {
        this.fullLoader.hide();
      }
    },

    showLoader: function () {
      this.fullLoader = this.$loading.show({
        // Optional parameters
        container: null,
        canCancel: false,
        height: 40,
        width: 40,
        loader: "spinner",
        color: "#333333",
        backgroundColor: "#EEF2FE",
        opacity: 0.6,
      });
    },
  },
};
</script>

<style scoped>
.revo-grid {
  height: 50%;
}

.table-row {
  cursor: pointer;
}

.table-row:hover {
  background-color: #f5f5f5;
}

.perm-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.perm-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--border-color, #E5E5E3);
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary, #555);
  background: var(--bg-surface, #fff);
  transition: all 0.15s ease;
  user-select: none;
  margin: 0;
}

.perm-item:hover {
  border-color: var(--accent, #E8751A);
  background: rgba(232, 117, 26, 0.04);
}

.perm-item-active {
  border-color: var(--accent, #E8751A);
  background: rgba(232, 117, 26, 0.08);
  color: var(--accent, #E8751A);
}

.perm-item-active .perm-icon .icon {
  color: var(--accent, #E8751A);
}

.perm-icon .icon {
  font-size: 16px;
  color: var(--text-muted, #8C8C8C);
  transition: color 0.15s;
}

.perm-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.perm-text {
  white-space: nowrap;
}

.perm-item-sm {
  padding: 6px 12px;
  font-size: 12px;
}
</style>
